export default "__VITE_ASSET__B6BM7WPA__"